import { BS_IMAGE_FIGURE_TYPE, BS_IMAGE_IMG_TYPE } from './constants';
import { resolveBsImageImg } from './utils';
import { syncAllFigureStyles, syncFigureStylesFromImage } from './figureStyleSync';

export function registerImageFigureBehavior(editor) {
    editor.on('component:selected', (component) => {
        if (component?.get('type') !== BS_IMAGE_FIGURE_TYPE) return;

        const image = resolveBsImageImg(component);
        if (image) {
            editor.select(image);
        }
    });

    editor.on('component:remove', (removed) => {
        if (!removed || removed.get('type') !== BS_IMAGE_IMG_TYPE) return;

        const figure = removed.parent();
        // Skip if remove was already delegated to the figure (parent gone / not in tree).
        if (
            figure?.get('type') === BS_IMAGE_FIGURE_TYPE &&
            figure.parent?.()
        ) {
            figure.remove();
        }
    });

    editor.on('component:styleUpdate', (component) => {
        if (component?.get('type') === BS_IMAGE_IMG_TYPE) {
            syncFigureStylesFromImage(editor, component);
        }
    });

    editor.on('change:device', () => {
        const selected = editor.getSelected?.();
        if (selected?.get('type') === BS_IMAGE_IMG_TYPE) {
            syncFigureStylesFromImage(editor, selected);
        }
    });

    editor.on('device:select', () => {
        const selected = editor.getSelected?.();
        if (selected?.get('type') === BS_IMAGE_IMG_TYPE) {
            syncFigureStylesFromImage(editor, selected);
        }
    });

    editor.on('load', () => {
        syncAllFigureStyles(editor);
    });
}
